module.exports = __webpack_public_path__ + "img/Group 22.97e4ac44.svg";